import { render } from "./Type.vue?vue&type=template&id=45b950cf&scoped=true"
import script from "./Type.vue?vue&type=script&lang=js"
export * from "./Type.vue?vue&type=script&lang=js"

import "./Type.vue?vue&type=style&index=0&id=45b950cf&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\gurmi\\Projects\\anyform\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b950cf"]])

export default __exports__